import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import toponyms from "./toponyms";
import toponymOfTheMonth from "./toponymOfTheMonth";
import staticData from "./staticData";
import administrativeTerritories from "./administrativeTerritories";
import map from "./Map";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
        toponyms,
        toponymOfTheMonth,
        staticData,
        administrativeTerritories,
        map,
    },
});

export default store;
